import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "./api";
import "../estilo.css";

export default function Planos() {
  const [produtos, setProdutos] = useState([]);
  const [pacotes, setPacotes] = useState([]);
  const [selectedRobots, setSelectedRobots] = useState(new Set());
  const [selectedCombo, setSelectedCombo] = useState(false);
  const [selectedTier, setSelectedTier] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    try {
      const [resProd, resPac] = await Promise.all([
        api.get("/api/produtos-ativos"),
        api.get("/api/pacotes-ativos"),
      ]);
      setProdutos(resProd.data || []);
      setPacotes(resPac.data || []);
    } catch (err) {
      console.error("Erro ao carregar produtos/pacotes:", err);
    } finally {
      setLoading(false);
    }
  };

  const toggleRobot = (id) => {
    setSelectedCombo(false);
    setSelectedRobots((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const toggleCombo = () => {
    setSelectedCombo(!selectedCombo);
    if (!selectedCombo) setSelectedRobots(new Set());
  };

  const limparSimulacao = () => {
    setSelectedRobots(new Set());
    setSelectedCombo(false);
    setSelectedTier(null);
  };

  const calcularResumo = () => {
    if (!selectedTier) return null;

    const pacote = pacotes[0];

    if (selectedCombo && pacote) {
      const preco = pacote.precos[selectedTier];
      if (!preco) return null;
      return {
        items: [
          {
            nome: pacote.nome,
            brl: Number(preco.valor_brl),
            usd: Number(preco.valor_usd),
          },
        ],
        slots: preco.slots_inclusos,
        totalBrl: Number(preco.valor_brl),
        totalUsd: Number(preco.valor_usd),
        extraBrl: Number(preco.valor_extra_brl),
        extraUsd: Number(preco.valor_extra_usd),
        isCombo: true,
      };
    }

    if (selectedRobots.size > 0) {
      const items = [];
      let totalBrl = 0;
      let totalUsd = 0;
      let slots = 0;
      let extraBrl = 0;
      let extraUsd = 0;

      selectedRobots.forEach((id) => {
        const prod = produtos.find((p) => p.id === id);
        if (prod && prod.precos[selectedTier]) {
          const preco = prod.precos[selectedTier];
          items.push({
            nome: prod.nome,
            brl: preco.valor_brl,
            usd: preco.valor_usd,
          });
          totalBrl += Number(preco.valor_brl);
          totalUsd += Number(preco.valor_usd);
          slots = preco.slots_inclusos;
          extraBrl = Number(preco.valor_extra_brl);
          extraUsd = Number(preco.valor_extra_usd);
        }
      });

      return {
        items,
        slots,
        totalBrl,
        totalUsd,
        extraBrl,
        extraUsd,
        isCombo: false,
      };
    }

    return null;
  };

  const resumo = calcularResumo();
  const pacote = pacotes[0];

  const calcEconomiaBrl = () => {
    if (!selectedTier || !pacote) return 0;
    const individual = produtos.reduce((sum, p) => {
      return (
        sum +
        (p.precos[selectedTier]
          ? Number(p.precos[selectedTier].valor_brl)
          : 0)
      );
    }, 0);
    const combo = pacote.precos[selectedTier]
      ? Number(pacote.precos[selectedTier].valor_brl)
      : 0;
    return individual - combo;
  };

  if (loading) {
    return (
      <div id="planos" className="container-fluid planos-section">
        <div className="text-center">
          <h2>Carregando planos...</h2>
        </div>
      </div>
    );
  }

  return (
    <div id="planos" className="container-fluid planos-section">
      <div className="text-center planos-header">
        <h2>Planos Quantum Trades</h2>
        <h4>
          Escolha os robôs que deseja utilizar e o tamanho da sua operação.
        </h4>
        <p className="planos-subtitle">
          Todos os planos incluem: acesso completo ao robô, atualizações,
          suporte, manual detalhado e portfólios prontos.
        </p>
      </div>

      <div className="planos-step">
        <h3 className="planos-step-title">
          <span className="planos-step-num">1</span>
          Escolha seus robôs
        </h3>

        <div className="planos-robots-grid">
          {produtos.map((prod) => (
            <div
              key={prod.id}
              className={`planos-robot-card ${
                selectedRobots.has(prod.id) ? "selected" : ""
              }`}
              onClick={() => toggleRobot(prod.id)}
            >
              <div className="planos-robot-check">
                {selectedRobots.has(prod.id) ? "✓" : ""}
              </div>
              <div className="planos-robot-icon">
                {prod.codigo === "ea"
                  ? "EA"
                  : prod.codigo === "bias"
                  ? "BI"
                  : "RK"}
              </div>
              <h4 className="planos-robot-name">{prod.nome}</h4>
              <p className="planos-robot-desc">{prod.descricao}</p>
              <div className="planos-robot-price">
                {selectedTier && prod.precos?.[selectedTier]
                  ? `R$ ${Number(prod.precos[selectedTier].valor_brl).toFixed(2)}`
                  : "A partir de R$ 20,00"}
                <span>/mês</span>
              </div>
            </div>
          ))}
        </div>

        {pacote && (
          <div
            className={`planos-combo-banner ${selectedCombo ? "selected" : ""}`}
            onClick={toggleCombo}
          >
            <div className="planos-combo-left">
              <strong className="planos-combo-title">
                {pacote.nome}
                <span className="planos-combo-badge">
                  Economia de R$ {Number(calcEconomiaBrl() || 0).toFixed(0)}
                </span>
              </strong>
              <p className="planos-combo-detail">{pacote.descricao}</p>
            </div>
            <div className="planos-combo-right">
              {selectedTier && pacote.precos[selectedTier] ? (
                <>
                  <span className="planos-combo-original">
                    R${" "}
                    {produtos
                      .reduce(
                        (s, p) =>
                          s +
                          (p.precos[selectedTier]
                            ? Number(p.precos[selectedTier].valor_brl)
                            : 0),
                        0
                      )
                      .toFixed(2)}
                  </span>
                  <span className="planos-combo-final">
                    R$ {Number(pacote.precos[selectedTier].valor_brl).toFixed(2)}
                    /mês
                  </span>
                </>
              ) : (
                <span className="planos-combo-final">Selecione um tier</span>
              )}
            </div>
          </div>
        )}

        {selectedRobots.size === produtos.length && !selectedCombo && (
          <div className="planos-combo-hint" onClick={toggleCombo}>
            Você selecionou todos os robôs! Ative o pacote e economize R${" "}
            {Number(calcEconomiaBrl() || 0).toFixed(2)}.
          </div>
        )}
      </div>

      <div className="planos-step">
        <h3 className="planos-step-title">
          <span className="planos-step-num">2</span>
          Tamanho da sua operação
        </h3>
        <p className="planos-step-sub">
          Quantas contas MT5 você precisa por robô?
        </p>

        <div className="planos-tiers-grid">
          {["starter", "trader", "pro"].map((tier) => {
            const tierData = {
              starter: {
                nome: "Starter",
                slots: 2,
                desc: "Ideal para começar",
              },
              trader: {
                nome: "Trader",
                slots: 5,
                desc: "Múltiplas estratégias",
              },
              pro: {
                nome: "Pro",
                slots: 10,
                desc: "Gestão profissional",
              },
            }[tier];

            const preco = produtos[0]?.precos?.[tier];

            return (
              <div
                key={tier}
                className={`planos-tier-card ${
                  selectedTier === tier ? "selected" : ""
                }`}
                onClick={() => setSelectedTier(selectedTier === tier ? null : tier)}
              >
                <h4 className="planos-tier-name">{tierData.nome}</h4>
                <p className="planos-tier-slots">{tierData.slots} contas MT5</p>
                <p className="planos-tier-desc">{tierData.desc}</p>
                {preco && (
                  <>
                    <div className="planos-tier-price">
                      R$ {Number(preco.valor_brl).toFixed(2)}
                      <span>/robô</span>
                    </div>
                    <p className="planos-tier-extra">
                      Conta extra: R$ {Number(preco.valor_extra_brl).toFixed(2)}
                    </p>
                    <p className="planos-tier-usd">
                      US$ {Number(preco.valor_usd).toFixed(2)}/robô
                    </p>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="planos-resumo">
        {resumo ? (
          <>
            {resumo.items.map((item, i) => (
              <div key={i} className="planos-resumo-row">
                <span>{item.nome}</span>
                <span>R$ {Number(item.brl).toFixed(2)}</span>
              </div>
            ))}
            <div className="planos-resumo-row">
              <span>
                Tier{" "}
                {selectedTier
                  ? selectedTier.charAt(0).toUpperCase() + selectedTier.slice(1)
                  : ""}{" "}
                — {resumo.slots} contas MT5 por robô
              </span>
              <span></span>
            </div>
            <div className="planos-resumo-total">
              <span>Total mensal</span>
              <span className="planos-resumo-valor">
                R$ {Number(resumo.totalBrl || 0).toFixed(2)}
              </span>
            </div>
            <div className="planos-resumo-usd">
              <span>Clientes internacionais</span>
              <span>US$ {Number(resumo.totalUsd || 0).toFixed(2)}</span>
            </div>
          </>
        ) : (
          <p className="planos-resumo-empty">
            Selecione pelo menos um robô e um tier para ver o resumo.
          </p>
        )}
      </div>

      <div
        className="text-center"
        style={{
          marginTop: 20,
          display: "flex",
          gap: 12,
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <Link
          to="/cadastro"
          state={{
            selectedRobots: Array.from(selectedRobots),
            selectedCombo,
            selectedTier,
            pacoteId: selectedCombo && pacote ? pacote.id : null,
          }}
          className={`btn btn-primary btn-lg ${!resumo ? "disabled" : ""}`}
        >
          Criar minha conta
        </Link>

        <button
          type="button"
          className="btn btn-default btn-lg"
          onClick={limparSimulacao}
        >
          Limpar simulação
        </button>
      </div>

      <div className="planos-disclaimer text-center">
        <p>
          <small>
            Os valores e condições podem ser ajustados ao longo do tempo.
            Resultados obtidos com o EA dependem de configurações, corretora,
            VPS, perfil de risco e condições de mercado. Desempenhos passados
            não garantem resultados futuros.
          </small>
        </p>
      </div>
    </div>
  );
}